<app-stages [stages]="stages" currentStage="Dane nieruchomości"></app-stages>
<br>
@if (!pending() && !loading()) {
  <form autocomplete="off" novalidate [formGroup]="form" (ngSubmit)='submitAndGoNext()'>
    <div class="row">
      <div class='col-md-3'>
        <div class='form-group' *ngIf='"city" as controlName'>
          <label [for]='controlName'>
            Miejscowość
          </label>
          <input
            [id]='controlName'
            [formControlName]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            placeholder='Wpisz tu miejscowość'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      <div class='col-md-3'>
        <div class='form-group' *ngIf='"postalCode" as controlName'>
          <label [for]='controlName'>
            Kod pocztowy
          </label>
          <input
            [id]='controlName'
            mask='00-000'
            [dropSpecialCharacters]='false'
            [formControlName]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            placeholder='Wpisz tu kod pocztowy'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      <div class='col-md-4'>
        <div class='form-group' *ngIf='"street" as controlName'>
          <label [for]='controlName'>
            Ulica
          </label>
          <input
            [id]='controlName'
            [formControlName]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            placeholder='Wpisz tu nazwę ulicy'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      <div class='col-md-2'>
        <div class='form-group' *ngIf='"houseNumber" as controlName'>
          <label [for]='controlName'>
            Nr domu
          </label>
          <input
            [id]='controlName'
            [formControlName]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            placeholder='Wpisz tu nr domu'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      <div class="col-md-4">
        <div class='form-group' *ngIf='"precint" as controlName'>
          <label [for]='controlName'>Obręb ewidencyjny *</label>
          <select
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [id]='controlName'
            [formControlName]='controlName'>
            <option value=''>Wybierz</option>
            <option *ngFor='let item of form.obrebList()' [value]='item?.name'>
              {{ item?.name }}
            </option>
          </select>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      <div class='col-md-4'>
        <div class='form-group' *ngIf='"registrationNumber" as controlName'>
          <label [for]='controlName'>
            Nr działki *
          </label>
          <input
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'
            placeholder='Wpisz tu numer działki'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
    </div>
  </form>
  <div class='application-actions'>
    <button
      type='button'
      class='btn btn-secondary'
      (click)='onCancel()'>
      <span>
        Wstecz
      </span>
    </button>
    <button
      type='button'
      class='btn btn-primary'
      (click)='submitAndGoNext()'>
      <span>Zapisz i przejdź dalej</span>
    </button>
  </div>
} @else {
  <app-spinner>
    {{ pending() ? 'Poczekaj trwa zapisywania danych...' : 'Poczekaj trwa ładowanie danych...' }}
  </app-spinner>
}
